import textActionM from '@fukku/styles/texts/textActionM.module.css'
import textBodyM from '@fukku/styles/texts/textBodyM.module.css'
import textBodyMStrong from '@fukku/styles/texts/textBodyMStrong.module.css'
import textBodySStrong from '@fukku/styles/texts/textBodySStrong.module.css'
import textHeadingS from '@fukku/styles/texts/textHeadingS.module.css'
import cx from 'classix'
import { applyStylesIf } from 'utils/applyStylesIf/applyStylesIf'

import styles from './TextLink.module.css'

export enum LinkType {
	Default = 'DEFAULT',
	Content = 'CONTENT',
	Inspirational = 'INSPIRATIONAL',
}

type TextLinkStates = {
	disabled?: boolean
	unselected?: boolean
	inverse?: boolean
	active?: boolean
}

export type TextLinkClassNameProps = TextLinkStates & {
	className?: string
	type?: LinkType
	size?: 's' | 'm' | 'l'
	withIcon?: boolean
}

const getTextClassName = (type: LinkType, size: 's' | 'm' | 'l') => {
	if (type === LinkType.Default) {
		return textBodyM.className
	}
	if (type === LinkType.Content) {
		if (size === 's') {
			return textBodySStrong.className
		}
		return textBodyMStrong.className
	}
	if (type === LinkType.Inspirational) {
		if (size === 's') {
			return textHeadingS.className
		}
		return textActionM.className
	}
	return ''
}

const getMostSpecificStyle = ({
	disabled = false,
	unselected = false,
	inverse = false,
	active = false,
}: TextLinkStates) => {
	if (disabled) {
		return styles.disabled
	}
	if (unselected && !inverse) {
		return styles.unselected
	}
	return cx(
		applyStylesIf(inverse, styles.inverse),
		applyStylesIf(active, styles.active)
	)
}

export function getTextLinkClassName({
	className,
	type = LinkType.Default,
	size = 'm',
	disabled = false,
	active = false,
	unselected = false,
	inverse = false,
	withIcon = false,
}: TextLinkClassNameProps) {
	const isDefault = type === LinkType.Default
	const isContent = type === LinkType.Content
	const isInspirational = type === LinkType.Inspirational
	const isSmall = size === 's'
	const isLarge = size === 'l'

	return cx(
		className,
		styles.link,
		getTextClassName(type, size),
		applyStylesIf(withIcon, styles.withIcon),
		getMostSpecificStyle({ disabled, unselected, inverse, active }),
		applyStylesIf(isDefault, styles.default),
		applyStylesIf(isContent, styles.content),
		applyStylesIf(isInspirational, styles.inspirational),
		applyStylesIf(isSmall, styles.small),
		applyStylesIf(isLarge, styles.large)
	)
}
